import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Typography, Fab } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PrintIcon from "@material-ui/icons/Print";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useStore } from "../../../store/index";
import { api } from "../../../api";
import { TerminalScreen } from "./EodDialogs/TerminalScreen";
import ReactToPrint from "react-to-print";
import { SnackBar } from "../../SnackBar";
import { eodItemStyles } from "../eodItemStyles";
import { ContinueEodDialog } from "./EodDialogs/EodProcessContinueDialog";
import { CancelEodDialog } from "./EodDialogs/EodProcessCancelDialog";
import { ErrorCaseDialog } from "./EodDialogs/ErrorCaseDialog";
import { UpdateErrorFlag } from "./EodDialogs/UpdateErrorDialog";
import "../Print.css";
import { FinancialReport } from "../EodFinancialReport/FinancialReport";
import { FinancialReportView } from "../EodFinancialReport/FinancialReportView";

type eodHomeProps = {
  goBackToMaster: () => void;
};

export const EodReportView: FunctionComponent<eodHomeProps> = ({
  goBackToMaster,
}) => {
  const classes = eodItemStyles();
  const componentRef = useRef<any>();
  const [user] = useStore("auth", "user");
  const [terminals, { updateTerminals }] = useStore("terminals");

  const [disableFab, setDisableFab] = useState<boolean>(true);
  const [overallProgress, setOverallProgress] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openErrorDialog, setOpenErrorDialog] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [continueDialog, setContinueDialog] = useState<boolean>(false);
  const [openCancelConfirmation, setOpenCancelConfirmation] = useState<boolean>(
    false
  );
  const [processErrorDialog, setProcessErrorDialog] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<any>();
  const [stageId, setStageId] = useState<number>(1);
  const [snackBarMessage, setSnackBarMessage] = useState<string>("");
  const [snackBarColor, setSnackBarColor] = useState<string>("");
  const [eodReportDetails, setEodReportDetails] = useState<any>();
  const [stageData, setStageData] = useState<Array<object>>([]);
  const [reportFlag, setReportFlag] = useState<boolean>(false);
  const [lastObjectOfArray, setLastObjectOfArray] = useState<any>();
  const [disablePrintButton, setDisablePrintButton] = useState<boolean>(false);
  const [openTerminalDialog, setOpenTerminalDialog] = useState<boolean>(false);
  const [webSocketClose, setWebSocketClose] = useState<boolean>(false);
  const [terminalDetails, setTerminalDetails] = useState<any>();
  const [updateErrorFlag, setUpdateErrorFlag] = useState<boolean>(false);

  useEffect(() => {
    (async function () {
      try {
        let store_id = user.store_id;
        let activeUser = await api.get(`stores/${store_id}/eod/request`);
        if (activeUser.request_id !== undefined) {
          setRequestId(activeUser.request_id);
          setStageId(activeUser.stage_id);
          setContinueDialog(true);
          setOpenErrorDialog(true);
        } else {
          setDisableFab(false);
        }
      } catch (error:any) {
        if (error.error.includes("is running eod process")) {
          setOpenErrorDialog(true);
          setErrorMessage(error.error);
        } else if (error.message === "You are not authorized for this action") {
          setOpenErrorDialog(true);
          setErrorMessage(error.message);
        } else {
          setSnackBarMessage("Something went wrong");
          setSnackBarColor("red");
        }
      }
    })();
  }, []);

  const webSocketStart = (requestId: any) => {
    // const websocket = new WebSocket(`ws://10.10.65.43:4214/eod-ws/${requestId}`);
    const websocket = new WebSocket(`ws://localhost:4214/eod-ws/${requestId}`);
    // const websocket = new WebSocket(
    //   `ws://10.10.65.64:4214/eod-ws/${requestId}`
    // );
    //  const websocket = new WebSocket(`ws://192.168.1.124:4214/eod-ws/${requestId}`);

    if (webSocketClose) {
      /* for closing websocket connection */
      websocket.onclose = (e: any) => {
        console.log("closed");
        backToList();
      };
      websocket.close();
    } else {
      websocket.onopen = () => {
        console.log("connected");
        console.log("open:connection state:", websocket.readyState);
        try {
          websocket.send(JSON.stringify("connected"));
        } catch (error) {}
      };

      websocket.onerror = (error: any) => {
        console.log("Error Occured: ", error);
      };

      websocket.onmessage = (message) => {
        /* listen to onmessage event */
        try {
          const processDetails = JSON.parse(message.data);
          if (processDetails !== undefined && processDetails !== null) {
            setStageData(processDetails);
            setLastObjectOfArray(processDetails[processDetails.length - 1]);
            processDetails.map((i: any) => {
              if (i.stage_id === 2) {
                setOverallProgress(20);
              } else if (i.stage_id === 3) {
                setOverallProgress(40);
              } else if (i.stage_id === 4) {
                setOverallProgress(60);
              } else if (i.stage_id === 5) {
                setOverallProgress(80);
              } else if (
                i.stage_id === 6 &&
                i.comments === "Eod Process Finished"
              ) {
                setOverallProgress(100);
              }
            });
          }
        } catch (error) {
          console.log("error>>>", error);
        }
      };
    }
  };

  const startOrContinueEodProcess = async (type: string) => {
    try {
      setOpenErrorDialog(false);
      setProcessErrorDialog(false);
      setOpenTerminalDialog(false);
      setReportFlag(false);
      setDisableFab(true);
      setIsLoading(true);
      let store_id = user.store_id;
      let APIResponse: any = {};

      if (type === "start") {
        /* start eod process */
        let objectToStartEod = await api.post(
          `stores/${store_id}/eod/request`,
          {},
          {}
        );
        setRequestId(objectToStartEod.id);
        webSocketStart(objectToStartEod.id);
        APIResponse = await api.post(
          `stores/${store_id}/eod/${objectToStartEod.id}/process`,
          {},
          { user }
        );
      } else {
        /* continue or retry eod process */
        webSocketStart(requestId);
        APIResponse = await api.post(
          `stores/${store_id}/eod/${requestId}/process?retry_stage_id=${stageId}`,
          {},
          { user }
        );
      }
      setEodReportDetails(APIResponse);
      if (APIResponse.status === false) {
        /* Error occured in the process in one of the stages */
        setStageId(APIResponse.retryStageId);
        if (APIResponse.retryStageId === 2) {
          setOverallProgress(20);
          if (APIResponse.enable_mark_defective === true) {
            setTerminalDetails(APIResponse.data.terminals);
            setOpenTerminalDialog(true);
          } else {
            setProcessErrorDialog(true);
          }
        } else {
          setProcessErrorDialog(true);
        }
      } else {
        /*Process completed condition */
        if (APIResponse.error_array.length > 0) {
          setOverallProgress(100);
          setUpdateErrorFlag(true);
        } else {
          setOverallProgress(100);
          setProcessErrorDialog(true);
          setWebSocketClose(true);
        }
      }

      window.onbeforeunload = () => {
        return "Data will be lost if you leave the page, are you sure?";
      };
    } catch (error:any) {
      if (error.message === "You are not authorized for this action") {
        setDisableFab(true);
        setOpenErrorDialog(true);
        setErrorMessage(error.message);
      } else {
        setIsLoading(false);
        setSnackBarMessage("Something went wrong");
        setSnackBarColor("red");
      }
    }
  };

  const markDeffectiveTerminals = async (offlineTerminals: Array<string>) => {
    try {
      setOpenTerminalDialog(false);
      await updateTerminals(offlineTerminals, requestId, user);
      startOrContinueEodProcess("retry");
    } catch (error) {
      console.log(error);
      setSnackBarMessage("Something went wrong");
      setSnackBarColor("red");
    }
  };

  const showFinanacialReport = () => {
    setProcessErrorDialog(false);
    setIsLoading(false);
    setDisableFab(true);
    setReportFlag(true);
  };

  const openCancelEodDialog = () => {
    setOpenCancelConfirmation(true);
  };

  const cancelEodProcess = async () => {
    try {
      const cancelResponse = await api.patch(
        `stores/${user.store_id}/eod/${requestId}/cancel`,
        {},
        { stage_id: 5 }
      );
      setOpenCancelConfirmation(false);
      setOpenErrorDialog(false);

      if (cancelResponse === true) {
        setSnackBarMessage("Successfully cancelled the current EOD");
        setSnackBarColor("green");
        setTimeout(() => {
          backToList();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const backToList = () => {
    setWebSocketClose(true);
    setOpenErrorDialog(false);
    setOpenCancelConfirmation(false);
    setErrorMessage("");
    setDisableFab(false);
    goBackToMaster();
    setReportFlag(false);
    setDisablePrintButton(false);
  };

  const updateError = () => {
    setUpdateErrorFlag(false);
    setProcessErrorDialog(true);
    setWebSocketClose(true);
  };

  return (
    <div className={classes.root}>
      <SnackBar
        status={snackBarMessage}
        onCloseError={backToList}
        color={snackBarColor}
      />
      <Paper className={classes.mainPaper}>
        <Grid container spacing={3}>
          <Grid item>
            <div className={classes.wrapper}>
              <Typography variant="h5" color="textPrimary">
                Would you like to start the EOD Process
                <Fab
                  variant="extended"
                  color="primary"
                  disabled={disableFab}
                  className={classes.fab}
                  onClick={() => {
                    startOrContinueEodProcess("start");
                  }}
                  style={{ width: "10em" }}
                >
                  Start
                </Fab>
                {isLoading ? (
                  <CircularProgress className={classes.buttonProgress} />
                ) : (
                  ""
                )}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Typography
                variant="h5"
                color="textPrimary"
                style={{ fontSize: "22px", fontWeight: "bold" }}
              >
                Overall Progress
              </Typography>
              <br />
              <LinearProgress
                variant="determinate"
                value={overallProgress}
                style={{ height: "0.5em" }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ fontSize: "22px", fontWeight: "bold" }}
                  >
                    Current module :
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ fontSize: "20px", textAlign: "left" }}
                  >
                    {lastObjectOfArray !== undefined
                      ? lastObjectOfArray.stage
                      : ""}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          {/* <Grid item xs={6}>
            <Paper className={classes.paper} style={{ minHeight: "4.3em" }}>
              <LinearProgress
                variant="determinate"
                value={singleProcessProgress}
                style={{ marginTop: "0.5em", height: "0.5em" }}
                className={classes.progressRoot}
              />
            </Paper>
          </Grid> */}

          <Grid
            item
            xs={12}
            //   style={{ display: navigationToEod === true ? "none" : "" }}
          >
            {reportFlag ? (
              <Paper className={classes.paper}>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                  spacing={3}
                >
                  <Grid item>
                    <Typography
                      style={{
                        fontSize: "1.3rem",
                        color: "black",
                        fontWeight: "bolder",
                      }}
                    >
                      Do you want to proceed with the Eod Process?{" "}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          disabled={disablePrintButton}
                          onClick={() => {
                            setDisablePrintButton(true);
                          }}
                        >
                          <PrintIcon />
                          Print
                        </Button>
                      )}
                      onAfterPrint={backToList}
                      content={() => componentRef.current}
                      pageStyle="@page { size:  5.8 in 8.3in,margin:1cm}"
                    />
                  </Grid>
                  {/* <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        // disabled={disablePrintButton}
                        // onClick={onCancelEod}
                      >
                        Go to Home
                      </Button>
                    </Grid> */}
                </Grid>
                <Grid item xs={12}>
                  <FinancialReportView
                    eodReportDetails={eodReportDetails.transaction_report}
                  />
                </Grid>
                <Grid item lg={12} style={{ display: "none" }}>
                  <FinancialReport
                    eodReportDetails={eodReportDetails.transaction_report}
                    ref={componentRef}
                  />
                </Grid>
              </Paper>
            ) : (
              ""
            )}
            {(openTerminalDialog || reportFlag) &&
            terminalDetails !== undefined ? (
              <Paper className={classes.paper}>
                <Grid container>
                  <TerminalScreen
                    terminalDetails={terminalDetails}
                    openTerminalDialog={openTerminalDialog}
                    markDeffectiveTerminals={markDeffectiveTerminals}
                    retryEodProcess={startOrContinueEodProcess}
                    eodReportDetails={eodReportDetails}
                    reportFlag={reportFlag}
                  />
                </Grid>
              </Paper>
            ) : (
              ""
            )}
          </Grid>
          {stageData.length > 0 ? (
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="h5" color="textPrimary" gutterBottom>
                      Completed Processes
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs
                    // style={{ display: navigationToEod ? "none" : "" }}
                  >
                    {stageData.map((stage: any) => (
                      <Grid container alignItems="center">
                        <Grid item>
                          <CheckCircleIcon style={{ color: "#64dd17" }} />
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="h6"
                            gutterBottom
                            style={{ textAlign: "start" }}
                          >
                            {stage.comments}
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Paper>
      {openErrorDialog ? (
        <ContinueEodDialog
          openErrorDialog={openErrorDialog}
          backToList={backToList}
          continueDialog={continueDialog}
          errorMessage={errorMessage}
          retryEodProcess={startOrContinueEodProcess}
          openCancelEodDialog={openCancelEodDialog}
        />
      ) : (
        ""
      )}
      {openCancelConfirmation ? (
        <CancelEodDialog
          openCancelConfirmation={openCancelConfirmation}
          cancelEodProcess={cancelEodProcess}
          backToList={backToList}
        />
      ) : (
        ""
      )}
      {processErrorDialog ? (
        <ErrorCaseDialog
          processErrorDialog={processErrorDialog}
          eodReportDetails={eodReportDetails}
          retryEodProcess={startOrContinueEodProcess}
          showFinanacialReport={showFinanacialReport}
          cancelEodProcess={cancelEodProcess}
        />
      ) : (
        ""
      )}
      {updateErrorFlag ? (
        <UpdateErrorFlag
          updateErrorFlag={updateErrorFlag}
          eodReportDetails={eodReportDetails}
          updateError={updateError}
        />
      ) : (
        ""
      )}
    </div>
  );
};
